/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agents_TitleInputs */

const en_home_agents_title = /** @type {(inputs: Home_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AutoCAD-style app an AI agent can actually drive`)
};

/**
* | output |
* | --- |
* | "The AutoCAD-style app an AI agent can actually drive" |
*
* @param {Home_Agents_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_agents_title = /** @type {((inputs?: Home_Agents_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agents_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_agents_title(inputs)
});
export { home_agents_title as "home.agents.title" }